import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import * as React from "react";
import { ICategory } from "../interfaces/ICategory";
import logo from "../assets/img/logo.png";
import { Link } from "react-router-dom";

type sideBarType = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  categories: ICategory[];
};
const SideBar: React.FC<sideBarType> = ({ open, setOpen, categories }) => {
  return (
    <div>
      <React.Fragment>
        <SwipeableDrawer
          anchor="left"
          open={open}
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
        >
          <Box
            sx={{ width: 250 }}
            role="presentation"
            onClick={() => setOpen(false)}
            onKeyDown={() => setOpen(false)}
          >
            <Box className="p-6 justify-center flex border-b-2">
              <Link to="/">
                <img src={logo} className="w-fit" />
              </Link>
            </Box>
            <List sx={{ p: 0 }}>
              {categories &&
                categories.map((category: ICategory) => (
                  <ListItem
                    sx={{ borderBottom: "1px solid #0000001f"}}
                    key={category.id}
                    disablePadding
                  >
                    <ListItemButton>
                      <ListItemText
                        sx={{ a: { fontSize: 13 } }}
                        primary={
                          <Link to={`/category/${category.slug}`}>
                            {category.name}
                          </Link>
                        }
                      />
                    </ListItemButton>
                  </ListItem>
                ))}
            </List>
          </Box>
        </SwipeableDrawer>
      </React.Fragment>
    </div>
  );
};

export default SideBar;
